import { Button as NextUIButton } from '@heroui/react';
import { getLiveLayoutColors } from '@components/RunOfShow/helper/presentationLive';

const ShowAnswerButton = ({ interactionId, showAnswerMap, setShowAnswerMap, layoutTheme = 'dark' }) => {
  const colors = getLiveLayoutColors(layoutTheme);

  const handleOnClick = () => {
    setShowAnswerMap({ ...showAnswerMap, [interactionId]: !showAnswerMap[interactionId] });
  };

  const isAnswerShown = showAnswerMap[interactionId] === true;
  return (
    <NextUIButton className={`${colors.containerColor} rounded-full px-6 h-12!`} onClick={handleOnClick}>
      <p className={`font-Inter ${colors.textColor} text-sm`}>
        {isAnswerShown ? 'Hide correct answer' : 'Show correct answer'}
      </p>
    </NextUIButton>
  );
};

export default ShowAnswerButton;
